<script setup>
// import { ref } from 'vue';
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Vehicle Info - ID: {{ model.vehicle.id }}</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Vehicle No</label>
                            <input class="form-control" v-model="model.vehicle.vehicleno" id="input_lorry_no" type="text" placeholder="KCB 8028" disabled />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Type</label>
                            <select class="form-control" v-model="model.vehicle.type" @change="showPuspakom">
                                <option value="0">Car</option>
                                <option value="1">Lorry</option>
                                <option value="2">Motor</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Active</label>
                            <select class="form-control" v-model="model.vehicle.isexpired" >
                                <option value="0">Active</option>
                                <option value="1">Expired</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.vehicle.remark"  placeholder="Remark...." />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Insurance</label>
                            <input type="date" id="input_date" v-model="model.vehicle.insurance" class="form-control" >
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Roadtax</label>
                            <input type="date" id="input_date" v-model="model.vehicle.roadtax" class="form-control" >
                        </div>
                        <div class="col-md-3" v-show="vPuspakom">
                            <label for="example-text-input" class="form-control-label text-danger">Puspakom</label>
                            <input type="date" id="input_date" v-model="model.vehicle.puspakom" class="form-control" >
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Delete</label>
                            <select class="form-control" v-model="model.vehicle.isdelete" >
                                <option value="0">Open</option>
                                <option value="1">Deleted</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="updateVehicle" style="float: right;" id="btn_update_vehicle">Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'vehicleEdit',
  data(){
    return {
    //   errorList: '',
    model:{
        vehicle:{
            id:'',
            vehicleno:'',
            type:'',
            puspakom: new Date().toISOString().slice(0,10),
            insurance: new Date().toISOString().slice(0,10),
            roadtax: new Date().toISOString().slice(0,10),
            remark:'',
            isexpired:'',
            isdelete:'',
            username:''
        }
      },
      vPuspakom:true,
    }
  },
  mounted(){
    this.model.vehicle.vehicleno = this.$route.params.id;
    this.getVehicleDetailsByID();
  },
  methods: {
    showPuspakom(){
        if(this.model.vehicle.type == 1){
            this.vPuspakom = true;
        }else{
            this.vPuspakom = false;
        }
    },
    updateVehicle(){
        this.model.vehicle.username = localStorage.getItem('username');
        // console.log(this.model.vehicle);
        axios.post('vehicle/updateVehicle',this.model.vehicle)
            .then(res => {
                alert(res.data.message);
                
            }).catch(function (error){
                console.log('Error',error.message);
            });
    },
    getVehicleDetailsByID(){
        // var mythis = this;
        axios.get('vehicle/getVehicleDetailsByID/' + this.$route.params.id)
            .then(res => {
            //   console.log(res.data.vehicleDetails[0]);
                this.model.vehicle = res.data.vehicleDetails[0];
                if(this.model.vehicle.type == 1){
                    this.vPuspakom = true;
                }else{
                    this.vPuspakom = false;
                }
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>